import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { useEffect } from 'react'
import { useMixpanel } from '@captaincause/lib/mixpanel'
import { SocialMedia } from '@captaincause/ui/SocialMedia'
import { tm } from '@captaincause/ui/tm'
import logo from 'assets/dift-logo-black.webp'
import { Button } from 'components/Button'

interface TermProps {
  href: string
  label: string
  id: string
}

function Term({ href, label, id }: TermProps) {
  const { trackLinks } = useMixpanel()

  useEffect(() => {
    trackLinks(`#footer-term-${id}`, `Click on Footer link`, { link: id })
  }, [id, label, trackLinks])

  return (
    <Button
      id={`footer-term-${id}`}
      href={href}
      variant="raw"
      underline
      className="p-2 pb-0 text-xs md:p-1 md:text-xs"
    >
      {label}
    </Button>
  )
}

export function SmallFooter({ className = '' }: { className?: string }) {
  const { t } = useTranslation('footer.component')

  return (
    <footer
      id="footer"
      data-testid="footer"
      className={tm(
        'flex h-auto flex-col items-center border border-light-gray bg-white p-2 md:h-16 md:flex-row md:justify-between',
        className,
      )}
    >
      <Button
        href="https://dift.com"
        variant="raw"
        className="mt-2 block h-auto w-[64px] md:ml-2 md:mt-0 md:p-0"
      >
        <Image
          src={logo}
          alt="Dift"
          style={{ width: 'inherit', height: 'inherit' }}
        />
      </Button>

      <div className="mt-2 flex items-center space-x-1 md:mx-4 md:mt-0 md:items-center md:space-x-4">
        <Term id="about" href="https://dift.com/about" label={t('about')} />
        <Term id="legal" href="https://dift.com/legal" label={t('legal')} />
        <Term id="cgu-cc" href="https://dift.com/cgu" label={t('cgu-cc')} />
        <Term
          id="privacy"
          href="https://dift.com/privacy"
          label={t('privacy')}
        />
      </div>
      <SocialMedia
        id="footer"
        className="md:align-items mt-4 hidden md:mr-4 md:mt-0 md:flex"
        iconSize="normal"
        socialsMedia={[
          {
            href: 'https://www.linkedin.com/company/dift-com/',
            icon: 'linkedin',
            label: t('linkedin-label'),
          },
          {
            href: 'https://www.youtube.com/channel/UC1rcA68A868I-gVHXjJuwPA',
            icon: 'youtube',
            label: t('youtube-label'),
          },
          {
            href: 'https://www.instagram.com/dift_com/',
            icon: 'instagram',
            label: t('instagram-label'),
          },
        ]}
      />
    </footer>
  )
}
